import { Injectable, NgZone } from '@angular/core';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor() { }
  private static mensajeDefault = 'Cargando datos ...';
  private _locked = false;
  mensaje = CoreService.mensajeDefault;
  mensajeProceso: string = '';

  lock(): void {
    this._locked = true;
  }

  unlock(): void {
    this._locked = false;
  }

  get locked(): boolean {
    return this._locked;
  }
}
